import Experience from './Experience/Experience.js';


const container = document.getElementById("container");
const experience = new Experience(container);